import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email("The email you have entered is incorrect")
      .max(60)
      .trim()
      .matches(/\./, " Please enter a valid email")
      .required("Please enter registered email")
  }),
  mapPropsToValues: props => ({
    email: ""
  }),
  validateOnMount: true,
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
